import * as React from 'react';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComplexValue, ComponentProps } from 'ui/common';
import styles from 'app/area/case/components/fact-box/fact-box.scss';
 
interface ConnectedCasesIntegrityStatusBarrierEvalFactItemProps extends ComponentProps, FactItemProps {
  integrityStatusBarrierEval: ComplexValue<number>;
}
export const ConnectedCasesIntegrityStatusBarrierEvalFactItem = (props: ConnectedCasesIntegrityStatusBarrierEvalFactItemProps) => {
  const { integrityStatusBarrierEval, title, linkDomain, url, urlOpenNew } = props;
  const icon = integrityStatusBarrierEval ? <Icon url={integrityStatusBarrierEval.icon} /> : null;
  const items = [{ key: 1, value: undefined, tooltip: integrityStatusBarrierEval?.description }];

  if (!integrityStatusBarrierEval?.value) {
    return null;
  }
  return <li className={`${styles.factLink} fact-item`}>
    <FactLink id={props.componentId} classNames={styles.factLink} section={linkDomain} url={url} urlOpenNew={urlOpenNew}>
      <BadgeList
        icon={icon}
        title={title}
        valueItems={items}
      />
    </FactLink>
  </li>;
};
